import { gsap } from 'gsap';

export function buttonCircularInit(el) {
  const content = el.querySelector('[data-icon]');

  gsap.set([el, content], { scale: 0, transformOrigin: '50% 50%' });
}

export function buttonCircularEnter(el) {
  const content = el.querySelector('[data-icon]');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to([el, content], {
      scale: 1,
      ease: 'flap',
      stagger: 0.3,
      duration: 1,
    }, 'start');

  return tl;
}

export function buttonCircularLeave(el) {
  const tween = gsap.to(el, {
    scale: 0,
  });

  return tween;
}
